import ModalController from '../modal_controller.js'
import { Modal } from 'bootstrap'
import dropdownApiValuesConfig from '../../modules/semantic-ui/dropdownApiValuesConfig.js'
import '../../entrypoints/modules/semantic-ui-dropdown'
import 'semantic-ui-transition/transition.min.js'
import 'semantic-ui-transition/transition.min.css'
import 'semantic-ui-api/api.js'
import 'semantic-ui-search/search.min.js'
import 'semantic-ui-form/form.min.js'
import { trans, SEARCH_FOR_DOCUMENTS } from '../../translator'

/* double check if moving css and js imports work for dropdown */

export default class extends ModalController {
  static targets = ['select', 'menu']

  apiValuesResponseCallback = (response, uiSemanticsMenuElement) => {
    if (!response) {
      return
    }

    $(uiSemanticsMenuElement).html(response)
  }

  connect () {
    $(this.selectTarget).dropdown(dropdownApiValuesConfig(
      trans(SEARCH_FOR_DOCUMENTS, {}, 'meeting-templates'),
      '/documents_partial?search_term={query}',
      this.menuTarget,
      this.apiValuesResponseCallback
    ))
  }

  openModal () {
    $(this.selectTarget).dropdown('clear')
    super.openModal()
  }

  linkDocuments () {
    const documents = []
    const selected = $(this.selectTarget).dropdown('get item')

    $.each(selected, function (index, item) {
      const document = {}
      document.id = item.dataset.value
      document.name = item.innerHTML

      documents.push(document)
    })

    this.dispatch('submitted', { detail: { documents } })

    this.modal.hide()
  }
}
